// @flow
import Root from './Root.component';

export default Root;
